import { Resources } from "@/types/subject-schema";
import commandterms from "../../public/static/icons/resources/commandtermicon.svg";
import cramsheets from "../../public/static/icons/resources/cramsheeticon.svg";
import definitions from "../../public/static/icons/resources/definitionicon.svg";
import exambreakdown from "../../public/static/icons/resources/exambreakdownicon.svg";
import flashcards from "../../public/static/icons/resources/flashcardicon.svg";
import iacriteria from "../../public/static/icons/resources/iacriteriaicon.svg";
import iaexamples from "../../public/static/icons/resources/iaexampleicon.svg";
import mockexams from "../../public/static/icons/resources/mockexamicon.svg";
import notes from "../../public/static/icons/resources/noteicon.svg";
import questions from "../../public/static/icons/resources/questionicon.svg";
import syllabus from "../../public/static/icons/resources/syllabusicon.svg";
import testbuilder from "../../public/static/icons/resources/testbuildericon.svg";
import topicTest from "../../public/static/icons/resources/topictesticon.svg";
import videos from "../../public/static/icons/resources/videoicon.svg";
import examtests from "../../public/static/icons/resources/examtesticon.svg";

export function getRawIconForResource(resource: Resources) {
  switch (resource) {
    case "videos":
      return videos;
    case "notes":
      return notes;
    case "definitions":
      return definitions;
    case "flashcards":
      return flashcards;
    case "questions":
      return questions;
    case "cram sheets":
      return cramsheets;
    case "topic tests":
      return topicTest;
    case "mock exams":
      return mockexams;
    case "test builder":
      return testbuilder;
    case "command terms":
      return commandterms;
    case "exam breakdown":
      return exambreakdown;
    case "ia examples":
      return iaexamples;
    case "ia criteria":
      return iacriteria;
    case "syllabus":
      return syllabus;
    case "exam tests":
      return examtests;
    case "individual topic test":
      return topicTest;
    case "test taker":
      return testbuilder;
  }
}
